module.exports = __webpack_public_path__ + "static/media/PM24.32b854d2.JPG";